export default "__VITE_ASSET__ec148865__"